import { useToast } from "contexts/ToastContext";
import { useState } from "react";
import { updateLegislativeDrafting } from "services/legislativeService";
import { CanShow } from "utils/authRules";
import { useTranslation } from "react-i18next";
import { LoadingIcon } from "utils/constant";
import { LEGISLATIVE_DRAFTING_REQUEST_STATUS } from "utils/constantValues";
import UploadDraftLaw from "./uploadDraftLaw";
import RequestForAdditionalInfo from "./uploadRequestForAdditionalInfo";
import { useAuth } from "contexts/AuthContext";

export default function ProsecutorRemark({ setFormState, formState }: { setFormState: any, formState: any }) {
    const contextData = useAuth();
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const { showToast } = useToast();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isRequestModalOpen, setIsRequestModalOpen] = useState(false);

    // Restrict to only LegalResearchProsecutor team leaders
    if (!(contextData?.user?.roles?.some((p) => p === "LegalResearchProsecutor") &&
          formState?.prosecutor_assignments?.find((prosecutor: any) => prosecutor.prosecutor_user_id === contextData?.user?.user_id)?.is_team_leader)) {
        return null;
    }

    const handleCloseModal = () => {
        setIsModalOpen(false);
    }
    const handleRequestCloseModal = () => {
        setIsRequestModalOpen(false);
    }

    const handleReject = () => {
    }

    const handleUploadProposalClick = () => {
    }

    const isArchived = String(formState?.status || formState?.current_status || "").toLowerCase() === "archived";

    return (
        <>
            {!isArchived &&
            <div className="mt-4 pb-8 border-b border-gray-200 flex flex-col sm:flex-row justify-between gap-3">
                <button
                    type="button"
                    className="flex-1 flex items-center justify-center gap-2 px-6 py-3 rounded-lg border border-[#0A1D39] text-[#0A1D39] font-semibold hover:bg-[#0A1D39]/5 transition-colors disabled:opacity-50"
                    onClick={() => setIsRequestModalOpen(true)}
                    disabled={loading}
                >
                    {loading ? (
                        <>{LoadingIcon} {t("Submitting") || "Submitting..."}</>
                    ) : (
                        <>
                            <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            {t("RequestForAdditionalInfo") || "Request for Additional Info"}
                        </>
                    )}
                </button>
                <button
                    type="button"
                    onClick={() => !loading && setIsModalOpen(true)}
                    disabled={loading}
                    className="flex-1 flex items-center justify-center gap-2 px-6 py-3 rounded-lg bg-[#0A1D39] text-white font-semibold hover:bg-[#13294d] transition-colors disabled:opacity-50"
                >
                    {loading ? (
                        <>{LoadingIcon} {t("Submitting") || "Submitting..."}</>
                    ) : (
                        <>
                            <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                            </svg>
                            {formState?.summary_of_comments
                                ? (t("ResubmitSummaryWrittenComments") || "Re-submit Summary Written Comments")
                                : (t("SummaryWrittenComments") || "Summary Written Comments")}
                        </>
                    )}
                </button>
            </div>
            }
            <UploadDraftLaw
                request={formState}
                setLegalResearch={setFormState}
                isOpen={isModalOpen}
                onClose={handleCloseModal}
                onUploadProposal={handleUploadProposalClick}
                type="register_directives"
            />
            <RequestForAdditionalInfo
                request={formState}
                setLegalResearch={setFormState}
                isOpen={isRequestModalOpen}
                onClose={handleRequestCloseModal}
                onUploadProposal={handleUploadProposalClick}
            />
        </>
    );
}
